import { styled } from "@material-ui/core/styles";
import { Checkbox } from "@material-ui/core";
import React from "react";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: 3,
  width: 12,
  height: 12,
  outline: "1px solid #707070",
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#006E7D",
  "&:before": {
    display: "block",
    width: 16,
    height: 16,
    content: '""',
  },
});

export default function CustomCheckbox({
  handleClick,
  row,
  isItemSelected,
  labelId,
  ...otherProps
}) {
  return (
    <Checkbox
      onClick={(event) => handleClick(event, row.selectionKey)}
      checked={isItemSelected}
      inputProps={{ "aria-labelledby": labelId }}
      sx={{
        "&:hover": { bgcolor: "transparent" },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...otherProps}
    />
  );
}
